import React from 'react'
import PropTypes from 'prop-types'
import { Badge, Col, Row } from 'react-bootstrap'

import styles from './style.module.scss'
import MyImage from '@shared/components/myImage'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import PlayerImg from '@shared/components/playerImg'
import { getImgURL, numDifferentiation } from '@shared/utils'
import CustomLink from '@shared/components/customLink'

const AuctionPlayerSingle = ({ className = '', player }) => {
  const teamURL = player?.oPrimaryTeam?.oImg?.sUrl || player?.oCountry?.oImg?.sUrl

  function PlayerCard() {
    return (
      <div className={`${styles.card} ${className} light-bg br-lg position-relative`}>
        <div className={`${styles.head} d-flex align-items-center`}>
          <div className="d-flex gap-2 gap-md-3 align-items-start flex-grow-1">
            <div className={`${styles.playerImg} mx-auto rounded-circle flex-shrink-0 overflow-hidden`}>
              <PlayerImg head={player?.oPlayer?.oImg} jersey={player?.oPrimaryTeam?.oJersey} enableBg />
            </div>
            <div className="flex-grow-1">
              <h5 className="mb-1 mb-md-2 d-flex align-items-center gap-1 gap-md-2">
                {player?.oPlayer?.sFullName}
                {/* <span className={styles.toppick}>
                <TopPickIcon />
              </span> */}
              </h5>
              <div className={`${styles.info} d-flex align-items-center`}>
                <div className="d-flex align-items-center">
                  <span className={`${styles.flag} me-1 me-sm-2 rounded-circle overflow-hidden flex-shrink-0`}>
                    <MyImage
                      src={teamURL ? getImgURL(teamURL) : teamPlaceholder}
                      width="48"
                      height="48"
                      alt={
                        (player?.oPrimaryTeam ? player?.oPrimaryTeam?.oImg?.sText : player?.oCountry?.oImg?.sText) ||
                        player?.oPlayer?.sFullName
                      }
                    />
                  </span>
                  {player?.oPrimaryTeam?.sTitle || player?.oCountry?.sTitle}
                </div>
                <span className="border-0 text-capitalize">{player?.sPlayingRole}</span>
                <Badge bg="secondary" className={`${player?.bCappedPlayer ? styles.capped : styles.uncapped} px-1 text-capitalize`}>
                  {player?.bCappedPlayer ? 'Capped' : 'Uncapped'}
                </Badge>
              </div>
            </div>
          </div>
          {player?.eAuctionStatus === 's' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.sold}`}>
              Sold
            </Badge>
          )}
          {player?.eAuctionStatus === 'us' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.unsold}`}>
              UnSOLD
            </Badge>
          )}
          {player?.eAuctionStatus === 'r' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
              Retained
            </Badge>
          )}
          {player?.eAuctionStatus === 'rtm' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
              RTM
            </Badge>
          )}
          {player?.eAuctionStatus === 't' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
              Transferred
            </Badge>
          )}
          {player?.eAuctionStatus === 'b' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
              Bidding
            </Badge>
          )}
          {player?.eAuctionStatus === 'd' && (
            <Badge bg="danger" className={`${styles.badge} ${styles.retained}`}>
              Draft
            </Badge>
          )}
        </div>
      </div>
    )
  }

  return (
    <Row className="gy-2 gx-3 mb-3 mb-md-4">
      <Col className="col-md-6">
        {player?.oPlayer?.oSeo?.sSlug ? (
          <CustomLink href={`/${player?.oPlayer?.oSeo?.sSlug}`}>
            <PlayerCard />
          </CustomLink>
        ) : (
          <PlayerCard />
        )}
      </Col>
      <Col className="col-md-6">
        <div className={`${styles.card} ${className} light-bg br-lg position-relative h-100`}>
          <div className={`${styles.prices} d-flex align-items-center justify-content-around text-center h-100`}>
            {player?.nBasePrice && (
              <div>
                <p className="font-semi mb-0">Base Price</p>
                <h6 className="fw-bold mb-0">{numDifferentiation(player?.nBasePrice)}</h6>
              </div>
            )}
            {player?.nSoldPrice && (
              <div>
                <p className="font-semi mb-0">Final Price</p>
                <h6 className="fw-bold mb-0">{numDifferentiation(player?.nSoldPrice)}</h6>
              </div>
            )}
            {player?.oTeam && (
              <div>
                <p className="font-semi mb-0">Team</p>
                <h6 className="fw-bold mb-0">
                  <div className="d-flex align-items-center">
                    <span className={`${styles.flag} me-2 rounded-circle overflow-hidden flex-shrink-0`}>
                      <MyImage
                        src={player?.oTeam?.oImg?.sUrl ? getImgURL(player?.oTeam?.oImg?.sUrl) : teamPlaceholder}
                        width="48"
                        height="48"
                        alt={player?.oTeam?.oImg?.sText || player?.oTeam?.sAbbr || 'Team'}
                      />
                    </span>
                    {player?.oTeam?.sAbbr}
                  </div>
                </h6>
              </div>
            )}
          </div>
        </div>
      </Col>
    </Row>
  )
}
AuctionPlayerSingle.propTypes = {
  className: PropTypes.string,
  player: PropTypes.object
}

export default AuctionPlayerSingle
